import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useParams } from "react-router-dom";
import TFObject from '../../components/TFObject';

const Review = ( { aid, uid, meta, r, load, loadRecips } ) => {
    let params = useParams();
    
    useEffect( () => {
        load( { aid: aid, uid: uid, rid: params.rid } );
        loadRecips( { aid: aid, uid: uid, rid: params.rid } );
    }, [ aid, uid, params.rid, load, loadRecips ] );

    useEffect( () => {
        document.title = `Third Floor - ${r.details.headline}`;
    }, [ r.details.headline ] );

    return (
        <TFObject key={params.rid} objType='review' obj={r} oid={params.rid} objPick={meta.picklist} header={meta.header} details={meta.details} sidebar={meta.sidebar} />
    )
}

const mapProps = ( state ) => ( {
    aid: state.user.aid,
    uid: state.user.email,
    meta: state.user.meta.review,
    r: state.reviews.current
} );
  
const mapDispatch = ( dispatch ) => ( {
    load: dispatch.reviews.loadReview,
    loadRecips: dispatch.reviews.loadReviewRelationships
} );
  
export default connect( mapProps, mapDispatch )( Review );